export default __webpack_public_path__ + "static/media/O-135.973871f5.png";